<template>
<div></div>
</template>

<script>
import OT from "@opentok/client";

export default {
    name: "publisher",
    props: {
        session: {
            type: OT.Session,
            required: false
        },
        opts: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            publisher: {},
            interval: {},
            stream: {},
        };
    },
    beforeDestroy() {
        console.log("beforeDestroy for openTok publisher")
        if (this.publisher) {
            this.publisher.destroy();
        }
    },
    mounted: function () {
        const publisher = OT.initPublisher(this.$el, this.opts, err => {
            if (err) {
                this.$emit("error", err);
            } else {
                this.$emit("publisherCompleted");
            }
        });
        this.publisher = publisher;
        this.$emit("publisherCreated", publisher);
        const publish = () => {
            this.session.publish(publisher, err => {
                console.log("Publisher streamId: ",publisher.streamId)
                if (err) {
                    this.$emit("error", err);
                } else {
                    this.stream = publisher.stream;
                    this.$emit("publisherConnected", publisher);
                }
            });
        };
        if (this.session && this.session.isConnected()) {
            publish();
        }
        if (this.session) {
            this.session.on("sessionConnected", publish);
        };
        this.getRate();
    },
    methods: {
        getRate() {
            var newThis = this;
            console.log("Getting rate.");
            this.interval = setInterval(function () {
                if (newThis.publisher && newThis.publisher.id) {
                    var rateh = newThis.publisher.videoHeight();
                    var ratew = newThis.publisher.videoWidth();
                    console.log("Publisher " + newThis.publisher.id + ": " + rateh+", "+ratew);
                } else {
                    console.log("Removing Publisher interval");
                    clearInterval(newThis.interval);
                }
            }, 5000);
        }
    },

};
</script>
